import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfirmPurchaseRequest } from 'src/app/models/confirmPurchaseRequest.model';
import { ConfirmPurchaseResponse } from 'src/app/models/confirmPurchaseResponse.model';
import { DaviPlataRequest } from 'src/app/models/daviPlataRequest.model';
import { DaviPlataResponse } from 'src/app/models/daviPlataResponse.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NativeDaviplataService {
  purchaseIntentionUrl = `${environment.urlglobal_api}/v4/daviplata/purchase-intention`;
  confirmPurchasenUrl = `${environment.urlglobal_api}/v4/daviplata/confirm`;

  constructor(private http: HttpClient) { }

  daviplataPurchaseIntention = (requestBody: DaviPlataRequest): Observable<DaviPlataResponse> => {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.http.post<DaviPlataResponse>(this.purchaseIntentionUrl, requestBody, headers)
      .pipe(map((response: DaviPlataResponse) => response));
  }

  confirmPurchase = (requestBody: ConfirmPurchaseRequest): Observable<ConfirmPurchaseResponse> => {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.http.post<ConfirmPurchaseResponse>(this.confirmPurchasenUrl, requestBody, headers)
      .pipe(map((response: ConfirmPurchaseResponse) => response));
  }
}